export default "__VITE_ASSET__C9_IzVYI__"